import React from "react"
import {
  withStyles,
  WithStyles,
  createStyles,
  Theme,
  Typography,
} from "@material-ui/core"

import Post from "../../../types/Post"
import PostLink from "../PostLink"

const styles = ({ breakpoints: { up } }: Theme) => {
  const xl = up("xl")
  return createStyles({
    root: {
      display: "block",
    },
    title: {
      marginBottom: "0.5rem",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      overflow: "hidden",
      [xl]: {
        marginBottom: "0.875rem",
      },
    },
  })
}

interface Props
  extends WithStyles<typeof styles>,
    Pick<Post, "slug" | "title"> {}

const Title = ({ classes, slug, title }: Props) => {
  return (
    <PostLink slug={slug} classes={{ root: classes.root }}>
      <Typography variant="h3" className={classes.title} color="textPrimary">
        {title}
      </Typography>
    </PostLink>
  )
}

export default withStyles(styles)(Title)
